import { isToken } from "@/utils/auth";
import type { RouteLocationNormalized } from "vue-router";

const environment = import.meta.env.VITE_MODE_NAME;
const LOGIN_URL = import.meta.env.VITE_APP_LOGIN_URL;
export function requireMainPermission(
  _to: RouteLocationNormalized,
  _from: RouteLocationNormalized,
  next: any
) {
  if (!isToken()) {
    if (environment === "locale") {
      next({
        path: "/login"
      });
      return;
    }
    window.location.href = LOGIN_URL;
    return;
  }
  next();
}
